import initJobsPage from '~/ci/jobs_page';

initJobsPage();
